// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"1dfec185","208":"d4b1c7d3","236":"ee9d31ee","353":"949baa82","512":"f646a7a3","549":"511b61fc","813":"b4cf6f20"}[chunkId] + ".chunk.js";
};